import { render, staticRenderFns } from "./AsideTopBar.vue?vue&type=template&id=f11671aa"
import script from "./AsideTopBar.vue?vue&type=script&lang=js"
export * from "./AsideTopBar.vue?vue&type=script&lang=js"
import style0 from "./AsideTopBar.vue?vue&type=style&index=0&id=f11671aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports